<template>
  <div>

    <div class="form-row pfm-switch" v-for="(option, index) in options" :class="{'selected': selected == option.value}" :key="option.value"
      @click="updated(option.value)">
      <div class="shipping-header header" >
        <div class='radio-wrap'>
          <label class="radio-label" v-if="option.key" v-localize="{key: option.key}"></label>
          <label class="radio-label" v-if="option.name">{{option.name}}</label>
        </div>
      </div>
    </div>

  </div>
</template>

<script type="text/javascript">
import Langs from '@/langs'

export default {
  name: 'readio-field',
  props: ['data', 'path', 'options', 'inner', 'default'],
  components: {
  },
  data() {
    return {
      values: {},
      selected: this.data[this.path]
    };
  },
  created() {
    // console.log('Radio with value', this.data[this.path])
    // Fill the values model for radios buttons
    this.options.forEach(o => {
      this.values[o.value] = this.data[this.path] == o.value
    })

    if (this.selected == undefined && this.default != undefined) {
      this.data[this.path] = this.default
    }
  },
  methods: {
    getImg(value) {
      return 'radio-icon-' + (value == this.selected ? 'on' : 'off') + '.png'
    },
    updated(value) {
      this.selected = value
      this.data[this.path] = value
      this.options.forEach(o => {
        this.values[o.value] = value == o.value
      })

      // console.log('Selected value', value, this.values)
      this.$nextTick(() => {
        this.$emit('change')
      })
    }
  }
};
</script>

<style lang='less' scoped>
@import '../../variables.less';

</style>
